<script lang="ts">
  import SectionBoard from "../../molecules/SectionBoard.svelte";
  import { onMount } from "svelte";
	import OrderSection from "../OrderSection.svelte";
	import DetailSection from "./DetailSection.svelte";
	import BlueButton from "../BlueButton.svelte";
	import { MasterService } from "../../services/master.service";
	import Pagination from "../../molecules/Pagination.svelte";
	import FormWithLabel from "../../molecules/FormWithLabel.svelte";
	import { MasterStationService } from "../../services/station.service";
	import { writable } from "svelte/store";
	import { ApiService } from "../../services/api.service";

	const name = 'station'
	const label = '駅'
	const service = new MasterStationService(name)
	let loading = service.store.loading
	let model = service.store.model
	let models = service.store.models
	let currentModels = service.store.currentModels
	let page = service.store.page
	let size = service.store.size
	let prefecture = service.prefecture
	let trainLine = service.trainLine
	let trainLines = service.trainLines
	let trainLineDisabledId = service.trainLineDisabledId
	let prefectureUnselected = { id: null }
	let trainLineUnselected = { id: null }
	const prefectures = writable([])
	$: disabledTrainLine = $prefecture === prefectureUnselected.id
	$: disabled = $prefecture === prefectureUnselected.id
		|| $trainLine === trainLineUnselected.id
 		|| $trainLines.length === 0
 		|| $trainLineDisabledId === $trainLine

	onMount(async () => {
		const ps = await ApiService.getMasterList('prefectures')
		prefectures.set(ps)
		prefectureUnselected = ps.find(r => r.label === '未選択')
		service.initPrefecture(prefectureUnselected)
	})
</script>

<div class="flex">
  <SectionBoard>
  	<h2 class="font-semibold mb-4">
			{label}
  	</h2>

		<FormWithLabel
			label="都道府県"
			input={service.handlePrefecture}
			value={$prefecture}
			inputType="select"
			options={$prefectures}
		/>

		<div class="mt-2">
			<FormWithLabel
				label="路線"
				input={service.handleTrainLine}
				value={$trainLine}
				inputType="select"
				options={$trainLines}
				disabled={disabledTrainLine}
			/>
		</div>

  	<BlueButton
			click={service.addStation}
			klass="mt-4"
			rounded
			disabled={disabled}
		>
  		追加
  	</BlueButton>

 		{#if $models.length !== 0}
  		<OrderSection
  			models={$currentModels}
  			handleDndConsider={service.handleDndConsider}
  			handleDndFinalize={service.handleDndFinalize}
  			handleModel={service.handleModel}
  			selected={$model}
  		/>

			<Pagination
				page={$page}
				result={$models.length}
				next={service.handleNext}
				previous={service.handlePrevious}
				klass="mt-4"
			/>
		{/if}
  </SectionBoard>

  {#if $model.id}
    <SectionBoard klass="ml-6">
    	<DetailSection
    		model={$model}
    	  handleLabel={service.handleLabel}
    	  handleOrder={service.handleOrder}
    	  handleDisabled={service.handleDisabled}
    	  save={service.save}
    	  remove={service.remove}
    	  loading={$loading}
				max={$size}
    	/>
    </SectionBoard>
  {/if}
</div>